import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CadastrarUserComponent, CadastroUserComponent } from './components';

export const CadastroUserRoutes: Routes = [
    {
        path: 'cadastro-user',
        component: CadastroUserComponent,
        children: [
            {
                path: '',
                component: CadastrarUserComponent
            }
        ]
    }
];

@NgModule ({
    imports: [
        RouterModule.forChild(CadastroUserRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class CadastroUserRoutingModule {
    
}